import React from 'react';
const GamificationDisplay = (props) => null;
export default GamificationDisplay;
